'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002410 from "./presto.-Login-Page-View$$anon$10.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002418 from "./presto.-Login-Page-View$$anon$18.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002420 from "./presto.-Login-Page-View$$anon$20.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00248 from "./presto.-Login-Page-View$$anon$8.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024 from "./presto.types$-Single-App-User$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$7() {
  this.b8a = null;
  this.b82 = null;
  this.b83 = false;
  this.b8b = null;
  this.b8c = false;
  this.b8f = null;
  this.b88 = null;
  this.b89 = false;
  this.b84 = null;
  this.b85 = false;
  this.b86 = null;
  this.b87 = false;
  this.b8d = false;
  this.b8e = false;
  this.b8a = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b8f = "SingleAppUser";
}
export { $c_Lpresto_LoginPageView$$anon$7 as $c_Lpresto_LoginPageView$$anon$7 };
$p = $c_Lpresto_LoginPageView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$7;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$7() {
}
export { $h_Lpresto_LoginPageView$$anon$7 as $h_Lpresto_LoginPageView$$anon$7 };
$h_Lpresto_LoginPageView$$anon$7.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.b8a;
});
$p.M = (function() {
  if ((!this.b83)) {
    this.b82 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b83 = true;
  }
  return this.b82;
});
$p.O = (function() {
  if ((!this.b8c)) {
    this.b8b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b8c = true;
  }
  return this.b8b;
});
$p.D = (function() {
  return this.b8f;
});
$p.t = (function() {
  if ((!this.b89)) {
    this.b88 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("details", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("application", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonatedBy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b89 = true;
  }
  return this.b88;
});
$p.N = (function() {
  if ((!this.b85)) {
    this.b84 = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00248.$c_Lpresto_LoginPageView$$anon$8(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002410.$c_Lpresto_LoginPageView$$anon$10(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002418.$c_Lpresto_LoginPageView$$anon$18())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.b85 = true;
  }
  return this.b84;
});
$p.Q = (function() {
  if ((!this.b87)) {
    this.b86 = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002420.$c_Lpresto_LoginPageView$$anon$20();
    this.b87 = true;
  }
  return this.b86;
});
$p.v = (function() {
  if ((!this.b8e)) {
    this.b8d = false;
    this.b8e = true;
  }
  return this.b8d;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee130) => ((p) => \u03b4scrutinee130.adL(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024.$m_Lpresto_types$SingleAppUser$())));
});
var $d_Lpresto_LoginPageView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$7, "presto.LoginPageView$$anon$7", ({
  Mt: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$7 as $d_Lpresto_LoginPageView$$anon$7 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$7.js.map
